import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette: {
        primary: {
            main: "#1d96cb",
        },
        secondary: {
            main: "#ffff",
        },
        custom: {
            main: "#000000",
            blue1: "#123763",
            blue2: "#205394",
            grey1: "#f6f7f9",
            text: "#205394",
            icons: "#377AF3",
            textGrey: "#787878",
        },
        body: {
            main: "#f5f5f5",
        },
        blue1: {
            main: "#123763",
        },
    },
    typography: {
        fontFamily: "Montserrat, regular",
    },
});
